/* Creazione della polyline del percoso */

import L, { imageOverlay } from "leaflet";
import { memo } from "react";
import { useEffect,useState } from "react";
import React from 'react';
import  "leaflet-polylinedecorator";
import { useLeaflet } from "react-leaflet";
import { connect } from 'react-redux';
import ovalStart from './start.png'
import ovalEnd from './finish.png'
import './polyline.css';
import axios from 'axios'
import bus from './bus.png'
import stopIcon from './OvalStart.png'
import iconatpl from './iconatpl.svg'
import Axios from "axios";
import freccia from './right-arrow.svg'
import { changeMarkerError, changePolyReal } from "../../redux";

var polyUtil = require('polyline-encoded');

const Polyline = (props) => {
    
    const { map } = useLeaflet();
    const [coordinatePoly,setCoordinatePoly] = React.useState([])
    const [markerFermate,setMarkerFermate] = React.useState({})
    const [mezzo,setMezzo] = React.useState("")

    // Switch colore della polyline in base al tipo di percorso
    const switchMode = (mode) => {
      
      switch (mode) {
        case 'BUS':
          return {
            color: '#007ac9',
            weight: 8
          }
        case 'RAIL':
          return {
            color: '#a30b01',
            weight: 8
          }
        case 'TRAM':
          return {
            color: '#00985f',
            weight: 8
          }
        case 'SUBWAY':
          return {
            color: '#00985f',
            weight: 8
          }
        case 'FUNICULAR':
          return   {
            color: '#00985f',
            weight: 8
          }          
        case 'GONDOLA':
          return {
            color: '#00985f',
            weight: 8
          }
        case 'FERRY':
          return {
            color: '#00b9e4',
            weight: 8
          }
        case 'AIRPLANE':
          return {
            color: '#12b08b',
            weight: 8
          }
        case "WALK":
          return {
            color: '#007ac9',
            weight: 8,
            dashArray: '2, 20', 
            dashOffset: '5'
          }
        case "CAR":
          return {
            color: '#01754B',
            weight: 8
          }
        case "BICYCLE":
          return {
            color: '#f2b62d',
            weight: 8
          }
        case "Inactive":
          return {
            color: '#7A7A7A',
            weight: 8
          }
        default:
          return {
            color: '#007ac9',
            weight: 8,
            
          }
      }
      
    }
    const switchMode2 = (key) => {
      switch (key) {
        default:
          return{
            color: '#FF0000',
            weight: 5,            
            /* lineCap : 'square',     
            lineJoin : 'arcs' */
          }
      }
    }
    const drawImage2 = (image) => {

    var iconStart = L.icon({
        iconUrl: image,
        iconSize: [30, 30],
        iconAnchor:   [15  , 35],
        popupAnchor:  [0, -35]
      });
      return iconStart
    }
    
    var pointStop = L.icon({
      iconUrl: stopIcon,
      iconSize:     [10, 10],
      iconAnchor:   [5  , 5],
      popupAnchor:  [0, -35]
    });

    // Switch colore della polyline in base al tipo di percorso
    
    
    const removeOldLayer2= () => {
      map.closePopup()
      map.eachLayer(element => {
        if(element.options.nome === "busFermate" || element.options.nome === "Polyline" || element.options.nome === "TripPolyline" || element.options.nome === "stop"){
          try {
              element.removeFrom(map)
          }
          catch(e) {}
        }
      });
    }
     
    //Rimozione Layer
    const removeOldLayer= () => {
      
      map.closePopup()
      map.eachLayer(element => {
        
        if (element._path !== undefined || element.options.nome === "start" || element.options.nome === "end"  ) {
          try {
            element.removeFrom(map)
          }
          catch(e) {}
        }
      });
    }

    const removeTripPolyline= () => {
      //map.closePopup()
      map.eachLayer(element => {
        if(element.options.nome === "TripPolyline" || element.options.nome === "stop"){
          try {           
              element.removeFrom(map)
          }
          catch(e) {}
        }
      });
    }

    // Inserimento immagine
    const drawImage = (image) => {

                var iconStart = L.icon({
                  iconUrl: image,
                  iconSize: [30, 30],
                  iconAnchor:   [15  , 35],
                  popupAnchor:  [0, -35]
                });
          return iconStart
    }
    
    // EX FROM CMR
    const addPolyline2 = () =>{
      var polytemp = []
        var pointTemp = []
        var polytemp2 = []
        var pointTemp2 = []
        var pointMezzo = []
        var myRenderer = L.svg({ padding: 0.5,icon :drawImage(freccia)});
                         
     axios.get(`${window.configFile.httpProxy.urlCMRPolyline}/${props.aziendaRealTime.aziendaRealTime}/${props.lineaRealTime.lineaRealTime}`)
     .then(response =>{
       
       response.data.dataPL[0].items.map(x=>{
         
         x.features.map(y =>{
           
           if(y.geometry.type === "LineString"){
             
            polytemp2.push(y.geometry.coordinates)
            
              for(const poliline2 of polytemp2){
                 let poly2 = L.polyline(poliline2 ,switchMode2() )
                poly2.addTo(map)  
                L.polylineDecorator(polytemp2, {
                  patterns: [
                      // defines a pattern of 10px-wide dashes, repeated every 20px on the line
                      {offset: 25, repeat: 195,symbol: L.Symbol.arrowHead({pixelSize: 10, pathOptions: {stroke: true,iconAnchor:[15,35],color:'#FF0000',fillOpacity: 1,
                      weight: 0}})}
                  ],nome:"Polyline"
              }).addTo(map);
              map.fitBounds(poly2.getBounds());
               }
         
       }else if(y.geometry.type === "Point"){
          
            pointTemp2.push(y.geometry.coordinates)
            
            /* for(const markerino2 of pointTemp2){
              let marker2 = L.marker(markerino2,{icon: drawImage2(iconatpl)})
              marker2.addTo(map) 
             } */
            
       }
         })
       })
       response.data.dataVP[0].map(x=>{
         
         pointMezzo.push([x.Latitude,x.Longitude])
         
          for(const markerino3 of pointMezzo){
          
         let marker3 = L.marker(markerino3,{icon: drawImage2(bus),nome:"busFermate"})
          
         
          marker3.addTo(map) 
          
         } 
         //setMarkerFermate(marker3)
       })

       
      })


     
        
      }

      const addTripPolyline = async () =>{
      
        if(props.lineaRealTime.lineaRealTime && props.lineaRealTime.lineaRealTime !== ""){
        await axios.get(`${window.configFile.httpProxy.urlShape}/${props.lineaRealTime.lineaRealTime}`,{headers: window.tp_headers})
            .then(response =>{    
              if(response.data[0]){
                if(response.data[0].shape ){
                  let encoded = response.data[0].shape      
                  let latlngs = polyUtil.decode(encoded);
                  let poly2 = L.polyline(latlngs , {nome: "TripPolyline",color: '#FF0000'})
                  poly2.addTo(map) 
                  L.polylineDecorator(poly2, {
                    patterns: [
                        // defines a pattern of 10px-wide dashes, repeated every 20px on the line
                        {offset: 25, repeat: 195,symbol: L.Symbol.arrowHead({pixelSize: 20, pathOptions: {stroke: true,iconAnchor:[15,35],color:'#FF0000',fillOpacity: 1,weight: 0}})}
                        //{offset: 0, repeat: 50, symbol: L.Symbol.arrowHead({pixelSize: 8, polygon: false, pathOptions: {stroke: true}})}
                    ],nome:"TripPolyline"
                  }).addTo(map);
                  map.fitBounds(poly2.getBounds(),{paddingTopLeft: [30,30],paddingBottomRight: [30,30]});   
                }
                if(response.data[0].stops ){
                  let encoded = response.data[0].stops      
                  let latlngs = polyUtil.decode(encoded);
                  const addMarkers = function(point) {
                    L.marker([point[0], point[1]],{icon:pointStop, nome: "stop"})
                      .addTo(map)
                  };
                  if (latlngs && latlngs.length > 0) latlngs.forEach(addMarkers);

                  if(!response.data[0].shape && latlngs && latlngs.length > 0){
                    let poly2 = L.polyline(latlngs , {nome: "TripPolyline",color: '#FF0000'})
                    poly2.addTo(map)
                    L.polylineDecorator(poly2, {
                      patterns: [
                          // defines a pattern of 10px-wide dashes, repeated every 20px on the line
                          {offset: 25, repeat: 195,symbol: L.Symbol.arrowHead({pixelSize: 20, pathOptions: {stroke: true,iconAnchor:[15,35],color:'#FF0000',fillOpacity: 1,weight: 0}})}
                      ],nome:"TripPolyline"
                    }).addTo(map);
                    map.fitBounds(poly2.getBounds(),{paddingTopLeft: [30,30],paddingBottomRight: [30,30]});   
                  }

                }

                // Aggiunta Popup con le informazioni 
                /*L.popup({nome: "popupLine", className: "popupTime"})
                .setLatLng(latlngs[parseInt(latlngs.length / 2)])
                .setContent(`<p>Percorso linea</p>`)
                .openOn(map);*/
              }
        })
  
  
       
          
        }}

    // Aggiunta Polyline
    const addPolyline = (legs,active) =>{
      
      //const enc2 = "{hcxFcstr@ELGf@If@Ch@p@nIBb@FrA@j@Cp@I\\ONcAj@U\\Md@q@rK??EbApBXVmAlAmElAqDzAgEtAwE`AgDr@_CL[\\If@AZ[p@aB@CdA}DJ]nBkFZiAb@_El@gGp@oH^uC\\oAj@wAz@_AbAm@hCi@tDs@d@G??fAQfCe@pAUHA@?tAWzBa@fASVEh@KLFFHFBFADAHEJIPKv@Un@O`@IDAfAS`BMdCE`F?`CT|Cr@vFpAxEhArCt@j@XxHvFdFvD`Aj@v@ZtATz@Dx@CfDi@DAbBWbDk@v@E|@Dx@Rt@Zd@Zd@b@bAxA|BpD@@d@v@nAnBzAbCzAbCdAbBBFDDZh@f@v@j@|@\\r@DRHb@F^BLDJHHJDF?FCDAHGPQT_@x@}Av@wAb@u@p@eAj@y@?A??nUe\\DG@@jDcFbAoA@C??r@cAf@s@jBkCzCeEfEaGzDmF@C^i@lCuDvI{LpBmCDGnAiBbB_ChCoD`AsA@AdA{AnBqCtBuC`BcCjAiBfC_EhC}D?AtBaDrCiE`AeAp@i@nByA^YJWD]AWAWCYBQFQr@cA@@BCn@_AhC{DdBgCtCmEh@u@hC{D@AnC{DRc@Tu@x@gDd@kBLIJ?H@fAb@zCsE?ARYNW\\i@Zc@d@s@Ze@^k@b@o@d@s@f@w@T]^k@V_@JQf@u@BEXc@`AyA`@o@fAaBjAgBdCsDlDmF??b@q@lAkBl@}@r@sAd@{@^u@Vq@Xy@\\{ARuAb@oCNaA?AxBuMh@_D?C??xDeVR_AZoAlBeGrB{Gh@{AfAaCf@u@zB_CxA_B~@yA|BoChA{@GCvDaDlAeApC{BjAaAXMvAc@bAMzASj@C`@On@m@Xm@xA{F|AeG^iAd@iApCkH@B@AjB{EdAaCrBiDdC_DvBqD??pCqFzAcDHS@?z@kBtBqEj@uAl@qBz@gD@C`@wAn@iBd@eAbAkCRc@Ry@b@oC?AZiBb@}BNw@fBDdHCQsAw@wE[cAs@i@cADqAg@y@w@e@g@KSEUCYd@wCHWb@cB|At@l@j@x@lABBlQrLF@DG^aA??|AiCCCrGgLZk@j@kAlA]bE{H?KCQkBgC"
      //const dec2 = polyUtil.decode(enc2);
      //var response = require('./polyline.json')
      
      const encoded = legs.legGeometry.points
      
      const latlngs = polyUtil.decode(encoded);
      
      //var poly3 = L.polyline(response.features[1].geometry.coordinates,/*  switchMode(active ? legs.mode : "Inactive") */ )
      var polyline = L.polyline(latlngs, switchMode(active ? legs.mode : "Inactive"))
      //var poly2 = L.polyline(response.features[0].geometry.coordinates  ,switchMode2()/* switchMode(active ? legs.mode : "Inactive") */ )
      /* poly2.addTo(map)
      poly3.addTo(map) */
      polyline.addTo(map)
      
      active ? polyline.bringToFront() : polyline.bringToBack()
      return polyline
     
    }

    
    
    useEffect(() => {

        try {              
            if (props.pathData.paths && props.pathData.paths.plan && props.pathData.paths.plan.itineraries) { 

              removeOldLayer()
              removeOldLayer2()
              
              props.pathData.paths.plan.itineraries.map((itinerario,index) => {

                  if (index === props.indexSelected.index ){
                    itinerario.legs.map(legs => {   
                      addPolyline(legs,true)
                      return null
                    })
                    let latlngs = []
                    let maxDistance = 0
                    for(let legIndex in itinerario.legs){
                      if(itinerario.legs[legIndex].distance > maxDistance){
                        const encoded = itinerario.legs[legIndex].legGeometry.points
                        latlngs = polyUtil.decode(encoded);
                        maxDistance = itinerario.legs[legIndex].distance
                      }
                      //latlngs = latlngs.concat(polyUtil.decode(encoded));
                    }
                    /*const encoded = itinerario.legs[parseInt(itinerario.legs.length / 2)].legGeometry.points
                    const latlngs = polyUtil.decode(encoded);*/
                    let time = parseInt(itinerario.duration / 60)
                    var hours = Math.floor(time /60)
                    var minutes = time % 60
                    const startTime = new Date(itinerario.startTime).toLocaleTimeString('it-IT');

                    // Aggiunta Popup con le informazioni temporali
                    L.popup({className: "popupTime"})
                          .setLatLng(latlngs[parseInt(latlngs.length / 2)])
                          .setContent(`<p>ITINERIARIO N. ${props.indexSelected.index+1}<br>Partenza: ${startTime}<br>Durata: ${hours} h, ${minutes} min</p>`)
                          .openOn(map);
                    
                    //map.fitBounds(poly.getBounds());   
                  } else {
                      itinerario.legs.map(legs => {   
                        addPolyline(legs,false)
                        return null
                      })
                      //map.fitBounds(poly.getBounds());   
                  } 
                return null
              })
              let latlng
              if(props.positionStart.lat) latlng = [props.positionStart.lat,props.positionStart.lng]
              else if(props.positionStart.positionStart.lat) latlng = [props.positionStart.positionStart.lat,props.positionStart.positionStart.lng]
              else if(props.positionStart.positionStart.split) {latlng = props.positionStart.positionStart.split(',')}
              let c1 = L.latLng(latlng[0], latlng[1]);
              if(props.positionEnd.lat) latlng = [props.positionEnd.lat,props.positionEnd.lng]
              else if(props.positionEnd.positionEnd.lat) latlng = [props.positionEnd.positionEnd.lat,props.positionEnd.positionEnd.lng]
              else if(props.positionEnd.positionEnd.split) {latlng = props.positionEnd.positionEnd.split(',')}
              let c2 = L.latLng(latlng[0], latlng[1]);
              map.fitBounds(L.latLngBounds(c1, c2), {paddingTopLeft: [30,30],paddingBottomRight: [30,30]});// correct zoom to fit markers


            } else {           
              //removeTripPolyline()    
              removeOldLayer()
              removeOldLayer2()
            }
          }
            catch(error){
              //removeTripPolyline()    
              removeOldLayer()
              removeOldLayer2()
            } 
           
    },[props.pathData,props.indexSelected]);
   
    
    useEffect(() => {

      try {              
          if (props.polyReal.polyReal === true){   

            removeTripPolyline()       
            addTripPolyline()                
              
          } else {           
            removeTripPolyline()    
          }
        }
          catch(error){
            removeTripPolyline()   
          } 
         
  },[props.polyReal]);
     


   
   
   /*  const start = [props.positionStart.positionStart]
    const end = [props.positionEnd.positionEnd]
    const startMarker = L.marker(start,{icon: drawImage(ovalStart),nome: "start"})
    const endMarker = L.marker(end,{icon: drawImage(ovalEnd),nome: "end"})
    startMarker.addTo(map)
    endMarker.addTo(map)
    map.fitBounds([start,end], {paddingTopLeft: [100,100],paddingBottomRight: [0,0]});    */
    return null;
    
};



const mapStateToProps = state => {
  return {
      pathData: state.path,
      indexSelected: state.index,
      polyReal : state.polyReal, 
      aziendaRealTime :state.aziendaRealTime,
      lineaRealTime:state.lineaRealTime,
      positionStart : state.positionStart,
      positionEnd : state.positionEnd,
      markerError : state.markerError,
      markerStart2 : state.markerStart2
  }
}
const mapDispatchToProps = dispatch => {
  return {   

      changePolyReal : (polyReal) => dispatch(changePolyReal(polyReal)), 
      changeMarkerError : (markerError) => dispatch(changeMarkerError(markerError))
      
  }
}
export default memo(connect(mapStateToProps,mapDispatchToProps)(Polyline));


